(function ($) {
  $(document).ready(function ($) {
    if ($(".collection__products").length) {
      /*****************************************************************
       * Toggle Flat or Model States
       *****************************************************************/
      $(".collection__products .imageFlip").on("click", function () {
        $(this).toggleClass("model-active");
        $(".collection__products .double__image").toggleClass("model-active");
      });

      /*****************************************************************
       * Boost Filter Custom Settings
       *****************************************************************/
      $(document).on(
        "click",
        "#shopify-section-collection-template-section .boost-pfs-filter-option-item, #shopify-section-collection-template-section .boost-pfs-filter-clear, #shopify-section-collection-template-section .boost-pfs-filter-top-sorting .Popover__Value, #shopify-section-collection-template-section .boost-pfs-filter-clear-all",
        function () {
          if (window.location == window.parent.location) {
            var pageUrl = window.location.href;
            if (pageUrl.indexOf("collections") > -1) {
              if (pageUrl.indexOf("?limit=24") > -1 && pageUrl.indexOf("?limit=24&") <= -1) {
                //               var newString = '';
                //               var pageUrl = pageUrl.replace('?limit=24',newString);
                //               window.location.href = pageUrl;
                var section_html = $("#overwrite_products").html();
                setTimeout(function () {
                  $(".tiv_list_wrapper .tiv_boost_filter").html(section_html);
                }, 500);
              }
            }
          }
        }
      );

      /*****************************************************************
       * Filter Color Swatches Hack
       *****************************************************************/
      $(window).on("load", function () {
        gatherColors();
      });

      $(document).on("click", ".CollectionFilters button", function () {
        setTimeout(function () {
          gatherColors();
        }, 500);
      });

      function gatherColors() {
        var colorItem = $(".CollectionFilters .boost-pfs-filter-option-color ul li.boost-pfs-filter-option-item");

        colorItem.each(function (i, el) {
          var colorOption = $(el).find(".boost-pfs-filter-option-value");
          var colorValue = colorOption.text().toLowerCase().replace(/ /g, "-");

          colorOption.attr("data-color", colorValue);
        });
      }
    }
  });
})(jQuery);
